import { useTranslation } from 'react-i18next';

import { TavoliMiei } from '@/components/gamehost/TavoliMiei';
import type { EtichetteTavoli, RisultatoTavoli } from '@/components/gamehost/TavoliMiei';
import { POSTI_1V1, POSTI_2V2 } from '@/lib/briscola/gioco';
import { briscolaApi } from '@/services/limuloBriscola';

/**
 * La lettura dei miei tavoli: la `briscolaApi.useGetMyBriscolaTablesQuery` del SUO servizio, come una FUNZIONE DI MODULO (stabile) che la lobby comune chiama a ogni render. Le letture non restano
 * in cache oltre la schermata (`keepUnusedDataFor: 0` nel servizio), e `refetchOnMountOrArgChange` la rifa a ogni apertura.
 */
const useTavoli = (): RisultatoTavoli => briscolaApi.useGetMyBriscolaTablesQuery(undefined, { refetchOnMountOrArgChange: true });

/** La rotta della partita: «Riprendi» chiede un ticket NUOVO come sempre. */
const rottaTavolo = (tableId: string): string => `/briscola/tavolo/${tableId}`;

/**
 * «I MIEI TAVOLI / RIPRENDI» della briscola: la lobby comune (`components/gamehost/TavoliMiei.tsx`, PR comune A3) consumata col gioco come parametro, senza copiarla. I testi sono del
 * catalogo `briscola` (it, en, es, el); `nomeTavolo(posti)` rende il formato: uno contro uno (2 posti), due contro due (4), «Tavolo» per un numero di posti che la briscola non conosce.
 */
export function TavoliMieiBriscola() {
  const { t } = useTranslation('briscola');
  const etichette: EtichetteTavoli = {
    titolo: t('hub.tavoli.titolo'),
    vuoto: t('hub.tavoli.vuoto'),
    inCorso: t('hub.tavoli.inCorso'),
    inAttesa: t('hub.tavoli.inAttesa'),
    riprendi: t('hub.tavoli.riprendi'),
    riprova: t('hub.tavoli.riprova'),
    guasto: { 'non-disponibile': t('hub.tavoli.guasto.non-disponibile'), rete: t('hub.tavoli.guasto.rete'), errore: t('hub.tavoli.guasto.errore') },
    nomeTavolo: (posti) => (posti === POSTI_2V2 ? t('modo.due') : posti === POSTI_1V1 ? t('modo.uno') : t('hub.tavoli.tavolo')),
  };
  return <TavoliMiei useTavoli={useTavoli} rottaTavolo={rottaTavolo} etichette={etichette} />;
}
